import React from 'react';
import styled from 'styled-components';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import type { TextAndIcons as T } from './types';
import Icon from 'components/Icons/Icon';

const Wrapper = styled.div`
  ${() => blockPadV({ pt: 'sm', pb: 'sm' })};
  ${() => blockPadH()};
`;

const Container = styled.div`
  ${() => blockW()};
`;

const Lead = styled.h4`
  text-align: center;
  max-width: 62.5rem;
  margin: 0 auto;
  ${({ theme }) => theme.gfx.mixins.mb(6)}
  ${({ theme }) => theme.mq.xl`
    max-width: 50%;
  `}
`;

const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  align-items: center;
  row-gap: 3rem;
  column-gap: 3rem;
  max-width: 50rem;
  margin: 0 auto;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    row-gap: 6rem;
    grid-template-columns: repeat(3, 1fr);
  `}
`;

const StyledIcon = styled(Icon)`
  max-width: 6rem;
  ${({ theme }) => theme.mq.md`
    max-width: unset;
  `}
`;

const TextAndIcons: React.FC<T> = ({ lead }) => {
  return (
    <Wrapper>
      <Container>
        <Lead>{lead}</Lead>
        <IconsContainer>
          <StyledIcon name="Mars" color="#FFF" />
          <StyledIcon name="K" color="#FFF" />
          <StyledIcon name="MiracleGro" color="#FFF" />
          <StyledIcon name="SpectrumHealth" color="#FFF" />
          <StyledIcon name="IBM" color="#FFF" />
          <StyledIcon name="Tovala" color="#FFF" />
          <StyledIcon name="Plume" color="#FFF" />
          <StyledIcon name="Starface" color="#FFF" />
          <StyledIcon name="Superplastic" color="#FFF" />
        </IconsContainer>
      </Container>
    </Wrapper>
  );
};

export default TextAndIcons;
